import { baseApi as api } from "../baseApi";
export const addTagTypes = ["Customers"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      listCustomers: build.query<ListCustomersApiResponse, ListCustomersApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v1/vendor/customers`,
            params: {
              name: queryArg.name,
              phone: queryArg.phone,
              email: queryArg.email,
              company: queryArg.company,
              page: queryArg.page,
              size: queryArg.size,
            },
          }),
          providesTags: ["Customers"],
        },
      ),
      createCustomer: build.mutation<
        CreateCustomerApiResponse,
        CreateCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/vendor/customers`,
          method: "POST",
          body: queryArg.customerForm,
        }),
        invalidatesTags: ["Customers"],
      }),
      getCustomer: build.query<GetCustomerApiResponse, GetCustomerApiArg>({
        query: (queryArg) => ({
          url: `/api/v1/vendor/customers/${queryArg.id}`,
        }),
        providesTags: ["Customers"],
      }),
      updateCustomer: build.mutation<
        UpdateCustomerApiResponse,
        UpdateCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/vendor/customers/${queryArg.id}`,
          method: "PUT",
          body: queryArg.customerForm,
        }),
        invalidatesTags: ["Customers"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as customersApi };
export type ListCustomersApiResponse =
  /** status 200 OK */ PageDataCustomerData;
export type ListCustomersApiArg = {
  /** Part of the name */
  name?: string;
  /** Digits contained in the phone number; other characters are ignored */
  phone?: string;
  /** Part of the email */
  email?: string;
  /** Part of the company */
  company?: string;
  /** Zero-based page number */
  page?: number;
  /** Rows per page; clamped to the server maximum */
  size?: number;
};
export type CreateCustomerApiResponse = /** status 201 Created */ CustomerData;
export type CreateCustomerApiArg = {
  customerForm: CustomerForm;
};
export type GetCustomerApiResponse = /** status 200 OK */ CustomerData;
export type GetCustomerApiArg = {
  id: number;
};
export type UpdateCustomerApiResponse = /** status 200 OK */ CustomerData;
export type UpdateCustomerApiArg = {
  id: number;
  customerForm: CustomerForm;
};
export type CustomerData = {
  company?: string;
  createdAt?: string;
  email?: string;
  id?: number;
  lastOrderAt?: string;
  name?: string;
  /** Orders linked to this customer */
  ordersCount?: number;
  /** E.164 */
  phone?: string;
};
export type PageDataCustomerData = {
  hasNext?: boolean;
  hasPrevious?: boolean;
  items?: CustomerData[];
  page?: number;
  size?: number;
  totalItems?: number;
  totalPages?: number;
};
export type CustomerForm = {
  company?: string;
  email?: string;
  name?: string;
  /** Any common format; normalised to E.164 */
  phone?: string;
};
export const {
  useListCustomersQuery,
  useLazyListCustomersQuery,
  useCreateCustomerMutation,
  useGetCustomerQuery,
  useLazyGetCustomerQuery,
  useUpdateCustomerMutation,
} = injectedRtkApi;
